require("!!/site/packages/javascript/carrot-theme/node_modules/script-loader/addScript.js")(require("!!/site/packages/javascript/carrot-theme/node_modules/raw-loader/index.js!/site/web/app/themes/carrot/bower_components/svg4everybody/dist/svg4everybody.js")+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script:///site/web/app/themes/carrot/bower_components/svg4everybody/dist/svg4everybody.js")


//////////////////
// WEBPACK FOOTER
// /site/packages/javascript/carrot-theme/node_modules/script-loader!./bower_components/svg4everybody/dist/svg4everybody.js
// module id = 47
// module chunks = 1